import { useRef, useEffect } from 'preact/hooks';

export default function usePrevious(value) {
	const ref = useRef();

	useEffect(() => {
		ref.current = value;
	}, [value]);

	return ref.current;
}
